import debounce from 'lodash/debounce'
import * as aTypes from '../../action-types'
import * as mTypes from '../../mutation-types'
import api from '../../../api'
import { unixFromNow, perPageFeedback } from '../../../utils'

/*
const sampleSummary = {
  count: 23
}
*/
/*
const sampleList = [{
  id: 'someId',
  time: '今天19:35',
  name: '王菲',
  mail: 'abc@dc.com'
}, {
  id: 'someId',
  time: '昨天19:35',
  name: '王菲',
  mail: 'abc@dc.com'
}, {
  id: 'someId',
  time: '2016.2.14',
  name: '王菲',
  mail: 'abc@dc.com'
}]
*/

const debouncedSearch = debounce(api.form.getFeedbackList, 300)

const state = {
  count: 0,

  list: [],

  currentPage: 1,
  hasMore: true,
  privateForm: false
}

const mapList = i => {
  return {
    id: i.id,
    time: unixFromNow(i.create_time || i.update_time),
    name: i.data.name,
    mail: i.data.email
  }
}

const actions = {
  [aTypes.FORM_GET] ({ commit, dispatch }, id) {
    commit(mTypes.SET_LOADING, { key: aTypes.FORM_GET, loading: true })
    api.form.getOne({
      success (res) {
        commit(mTypes.SET_NAV_TITLE, res.body.title)
        commit(mTypes.FORM_SET_FEEDBACK_SUMMARY, {
          count: res.body.formfill_count
        })
        commit(mTypes.SET_LOADING, { key: aTypes.FORM_GET, loading: false })
        dispatch(aTypes.ZHUGE_TRACK, {
          event: '到达表单反馈列表页',
          data: {
            '表单名称': res.body.title,
            '表单反馈条数': res.body.formfill_count
          }
        })
      },
      commit
    }, id)
  },
  [aTypes.FORM_GET_FEEDBACK_LIST] ({ commit }, { id, page, append, searchName }) {
    commit(mTypes.SET_LOADING, { key: aTypes.FORM_GET_FEEDBACK_LIST, loading: true })
    const search = searchName ? debouncedSearch : api.form.getFeedbackList
    search({
      success (res) {
        // 判断私密表单
        if (res.body.not_have_private_form_auth) {
          commit(mTypes.FORM_SET_FEEDBACK_PRIVATE_FORM, true)
        } else {
          const list = res.body.data.map(mapList)
          const pagination = res.body.meta.pagination
          const hasMore = pagination.current_page < pagination.total_page
          commit(mTypes.FORM_SET_FEEDBACK_LIST, { list, page, hasMore, append })
          commit(mTypes.FORM_SET_FEEDBACK_PRIVATE_FORM, false)
        }
        commit(mTypes.SET_LOADED_ID_OF_FORM_FEEDBACK, id)
        commit(mTypes.SET_LOADING, { key: aTypes.FORM_GET_FEEDBACK_LIST, loading: false })
      },
      commit
    }, { id, page, perPage: perPageFeedback, searchName })
  }
}

const mutations = {
  [mTypes.FORM_SET_FEEDBACK_LIST] (state, { list, page, hasMore, append }) {
    if (append) {
      state.list = state.list.concat(list)
    } else {
      state.list = list
    }
    state.currentPage = page
    state.hasMore = hasMore
  },
  [mTypes.FORM_SET_FEEDBACK_SUMMARY] (state, { count }) {
    state.count = count
  },
  [mTypes.FORM_SET_FEEDBACK_PRIVATE_FORM] (state, status) {
    state.privateForm = status
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/form/feedback.js